import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function HeroSection() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="hero" ref={ref} className={`relative w-full overflow-hidden bg-gradient-to-b from-background via-background to-secondary/30 pt-24 pb-16 md:pt-32 md:pb-24 transition-opacity duration-1000 ${isVisible ? "opacity-100" : "opacity-0"}`}>
      <div className="container mx-auto px-4 md:px-6">
        <div className="mx-auto max-w-4xl text-center">
          

          <h1 className={`mb-6 font-serif text-4xl font-medium leading-tight tracking-tight text-foreground md:text-6xl lg:text-7xl transition-all duration-700 delay-200 ${isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
            The Philosophy of <span className="italic text-primary/80">Clarity</span>
          </h1>

          <p className={`mx-auto mb-10 max-w-2xl text-lg text-muted-foreground md:text-xl transition-all duration-700 delay-300 ${isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>When the heart stands at a crossroads, it seeks a sign - a sense of calm, a whisper of assurance, a quiet knowing.<div><br /></div><div>With quiet integrity, we help bring that knowing closer, so every step you take feels lighter, surer, and distinctly your own.</div></p>

          <div className={`flex flex-col items-center justify-center gap-4 sm:flex-row transition-all duration-700 delay-400 ${isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
            <Button asChild size="lg" className="h-12 px-8 text-base shadow-md">
              <Link to="/GetClarityPage">
                Schedule Private Consultation
                <ArrowRight className="ml-2 h-4 w-4" />
              </Link>
            </Button>
            <Button asChild variant="ghost" size="lg" className="h-12 px-8 text-base hover:bg-primary/5">
              <Link to="/OurApproachPage">Our Approach</Link>
            </Button>
          </div>
        </div>

        <div className={`mt-16 md:mt-24 transition-all duration-1000 delay-500 ${isVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`}>
          <div className="relative mx-auto w-full max-w-6xl overflow-hidden rounded-lg shadow-2xl shadow-primary/5 ring-1 ring-primary/5">
            <AspectRatio ratio={21 / 9}>
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1554289/img/abstract_modern_indian_architecture.png" alt="Abstract architectural detail symbolizing structure and transparency" className="h-full w-full object-cover opacity-90" />
              <div className="absolute inset-0 bg-gradient-to-t from-background/20 to-transparent mix-blend-overlay" />
            </AspectRatio>
          </div>
        </div>
      </div>
    </section>;
}